import Request from '~/providers/Request';
import { normalizeText } from './normalizeText';

export const fetchCities = async (input, page, resolve) => {
  const normalizedInput = normalizeText(input);
  await Request.get(`/admin/cities?sort=name&direction=asc&qs=${normalizedInput}&page=${page}`).then(resp => {
    const items = resp.data.map( e => ({
      id: Number(e.id),
      name: `${e.name}`
    }));
    resolve(
      {
        total_count: resp.meta.total,
        items
      }
    );
  });
};
